import useGetUserInformation from "@/features/auth/useGetUserInformation";
import {
	clearPendingTransferIn,
	completePendingTransferIn,
	loadPendingTransferIn,
} from "@/features/transactions/pendingTransferIn";
import { transactionKeys } from "@/features/transactions/keys";
import { queryClient } from "@/query-client";
import { useEffect, useRef } from "react";

/**
 * Finishes an Add Funds whose card was charged but never settled in this browser (the page was
 * reloaded or closed, or the connection dropped): calls transfer_in/complete again, once, when
 * the logged-in app loads. Past the intent's expiry the API cron settles it instead.
 */
export default function ResumePendingTransferIn() {
	const guestId = useGetUserInformation().data?.id;
	const ranRef = useRef(false);

	useEffect(() => {
		if (ranRef.current || !guestId) return;
		ranRef.current = true;

		const pending = loadPendingTransferIn();
		// Another guest's transfer on this device is theirs to finish (or the cron's).
		if (!pending || pending.guestId !== guestId) return;
		if (Date.parse(pending.expiresAt) <= Date.now()) {
			clearPendingTransferIn(pending.transactionId);
			return;
		}

		completePendingTransferIn(pending)
			.catch(() => {
				// Still unanswered: kept for the next load, and the API cron settles it anyway.
			})
			.finally(() => {
				queryClient.refetchQueries({ queryKey: transactionKeys.all() });
				queryClient.refetchQueries({ queryKey: transactionKeys.balance() });
			});
	}, [guestId]);

	return null;
}
